const PROD_URL = 'https://plant.kyle.kiwi';

export const BASE_URL =
  process.env.NODE_ENV === 'development' ? window.location.origin : PROD_URL;

export const QR_PREFIX = `${PROD_URL}/p/`;
